import React from "react"
import Header from "./header"
import Footer from "./footer"

const Layout = ({ className, children, ...rest }) => {
  return (
    <div className={className} {...rest}>
      <Header />
      {children}
      <Footer />
    </div>
  )
}

export default Layout
